module.exports = __webpack_public_path__ + "static/media/sp_banner.2c460db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/sp_banner.png
// module id = 639
// module chunks = 0